var _style, _g, _path, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _g3, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpty({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#91B3FA;}\n\t.st2{fill:#BDD0FB;}\n\t.st3{opacity:0.5;}\n\t.st4{fill:url(#SVGID_2_);}\n\t.st5{fill:url(#SVGID_3_);}\n\t.st6{fill:url(#SVGID_4_);}\n\t.st7{fill:url(#SVGID_5_);}\n\t.st8{opacity:0.6;fill:#FFFFFF;}\n\t.st9{fill:url(#SVGID_6_);}\n\t.st10{fill:url(#SVGID_7_);}\n\t.st11{fill:url(#SVGID_8_);}\n\t.st12{fill:url(#SVGID_9_);}\n\t.st13{fill:url(#SVGID_10_);}\n\t.st14{fill:url(#SVGID_11_);}\n\t.st15{fill:url(#SVGID_12_);}\n\t.st16{fill:url(#SVGID_13_);}\n\t.st17{fill:url(#SVGID_14_);}\n\t.st18{fill:url(#SVGID_15_);}\n\t.st19{fill:url(#SVGID_16_);}\n\t.st20{fill:url(#SVGID_17_);}\n\t.st21{fill:url(#SVGID_18_);}\n\t.st22{fill:url(#SVGID_19_);}\n\t.st23{fill:url(#SVGID_20_);}\n\t.st24{fill:url(#SVGID_21_);}\n\t.st25{fill:url(#SVGID_22_);}\n\t.st26{fill:url(#SVGID_23_);}\n\t.st27{fill:url(#SVGID_24_);}\n\t.st28{fill:url(#SVGID_25_);}\n\t.st29{opacity:0.32;}\n\t.st30{fill:url(#SVGID_26_);}\n\t.st31{fill:url(#SVGID_27_);}\n\t.st32{fill:url(#SVGID_28_);}\n\t.st33{fill:url(#SVGID_29_);}\n\t.st34{fill:url(#SVGID_30_);}\n\t.st35{fill:url(#SVGID_31_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3514.22,
    y1: 3957.2305,
    x2: 1108.0623,
    y2: 968.9335
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2852.3,2778.8c-55.3,58.2-107.6,95.7-148.9,125.4C2217.7,3252.6,1643,3151,1520.9,3126.2 c-180.4-36.6-529-107.4-781-403.8c-381.3-448.4-322-1154.9-26.2-1621.3c54.1-85.3,339.9-558.8,920.8-634.7 c351.5-46,761.3,46.7,1058.1,295.3C3315.4,1283.6,3271.1,2337.8,2852.3,2778.8z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2080.2,1737.9c68.4-165.3,184.2-292,314.5-361.3c116.5-62,205.5-166.1,245.8-291.6 c4.2-13.2,9.1-26.4,14.5-39.5c82.2-198.8,270.7-309.6,421-247.5c150.3,62.1,205.4,273.7,123.2,472.5 c-16.8,40.7-38.1,77.6-62.5,110.2c-78.1,103.9-116.2,233.1-101.7,362.3c12.9,115.5-4.1,242.9-55.4,366.8 c-76.4,184.8-212.2,321.4-361.2,383.5c-56.4,23.5-108.2,57-152.4,99.1c-73.4,69.9-170.8,97.6-255.2,62.7 c-91-37.6-141.4-137.5-136.1-248.8c3-63-6.5-125.7-25.5-185.8C2004.2,2078.5,2011,1905.1,2080.2,1737.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2935.9,987.8c-74,123.3-143.9,248.8-212.6,375.1c-17.2,31.6-33.8,63.4-50.6,95.2l-25.1,47.7l-24.7,47.9 c-16.4,32-33.2,63.8-49.2,95.9l-48,96.5c-31.2,64.8-63,129.2-93,194.6c-15,32.6-30.7,65-45.1,97.9l-43.6,98.6 c-56.8,132.1-110.3,265.7-156.9,401.7l5.8,2.1l38.8-100.4l9.6-25.1l10.3-24.9l20.6-49.7l20.5-49.7c6.8-16.6,14.2-32.9,21.3-49.4 c14.4-32.9,28.5-65.8,43.1-98.6c59.3-130.7,120.3-260.6,184-389.3c32.3-64.1,64.1-128.4,96.9-192.3l24.5-48l24.9-47.8 c16.6-31.8,33.1-63.7,50-95.4c33.2-63.7,66.9-127.1,101-190.2c33.8-63.3,68.3-126.3,102.9-189.2L2935.9,987.8z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M3045.6,1404.7c1.5,0,3-0.6,4-1.9c123.6-150.1,132.3-278.8,117.9-360.3c-15.7-88.6-60.2-140.7-62-142.9 c-1.9-2.2-5.2-2.4-7.4-0.5c-2.2,1.9-2.4,5.2-0.5,7.4c0.4,0.5,44.7,52.5,59.7,138.4c13.9,79.3,5.1,204.5-115.7,351.3 c-1.8,2.2-1.5,5.5,0.7,7.3C3043.3,1404.3,3044.4,1404.7,3045.6,1404.7z"
  })))), /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2299.8,2127.5c82-90.8,185.6-145.9,285.3-160.7c89.2-13.3,170.3-60,225.2-131.5 c5.8-7.5,11.9-14.9,18.4-22.1c98.6-109.2,245.3-137.4,327.6-63.1c82.3,74.4,69.1,223.1-29.5,332.3 c-20.2,22.3-42.3,41.3-65.6,56.6c-74.1,49-128.3,123.5-148.8,210c-18.3,77.3-58.5,155.4-120,223.5 c-91.7,101.5-210.4,158.4-320.5,164.3c-41.6,2.2-82.7,12-120.8,29c-63.3,28.2-132.3,23.8-178.5-18 c-49.9-45-59.3-120.8-30.3-191.3c16.4-39.9,24.7-82.4,26.4-125.5C2172.6,2329.3,2216.9,2219.3,2299.8,2127.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 2184.2065,
    y1: 2255.1802,
    x2: 3025.3271,
    y2: 2255.1802
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M3022.6,1840.1c-75.9,62.5-149.8,127.3-223,192.9c-18.3,16.4-36.3,33.1-54.4,49.7l-27.1,24.9l-26.9,25.2 c-17.9,16.9-36,33.5-53.7,50.5l-53.1,51.2c-35,34.6-70.2,68.8-104.5,104c-17.2,17.6-34.7,34.8-51.5,52.7l-50.7,53.5 c-66.9,72.1-132,145.8-193.3,222.7l3.3,2.7l48-55.8l12-14l12.3-13.7l24.7-27.3l24.6-27.3c8.2-9.1,16.7-18,25.1-26.9 c16.8-17.9,33.5-35.9,50.4-53.6c68.2-70.6,137.3-140.3,207.9-208.6c35.5-33.9,70.8-68,106.5-101.7l26.8-25.3l27-25.1 c18-16.7,35.9-33.4,54.1-50c36-33.4,72.2-66.5,108.7-99.4c36.3-33,73-65.7,109.7-98.3L3022.6,1840.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 2969.5715,
    y1: 1957.9821,
    x2: 3161.6211,
    y2: 1957.9821
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M2971.9,2120.7c1,0.4,2.2,0.4,3.2-0.1c125.3-66.3,167.2-150.5,180.4-209.4c14.3-64-1-111.6-1.6-113.6 c-0.7-2-2.8-3.1-4.8-2.4c-2,0.7-3.1,2.8-2.4,4.8c0.2,0.5,15.3,47.9,1.4,109.9c-12.9,57.2-53.9,139.1-176.4,203.9 c-1.9,1-2.6,3.3-1.6,5.1C2970.4,2119.8,2971.1,2120.3,2971.9,2120.7z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 755.9548,
    y1: 2738.1211,
    x2: 4328.5801,
    y2: -1358.4829
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M813.3,470.6h1867.1c50.9,0,91.9,58.4,91,129.5l-26.3,2024.7c-1.2,95.3-57.3,171.3-172.1,170.1l-1767.7-31 c-29.1-0.5-55.1-18.2-66.3-45c-9.3-22.3-17.6-51.3-17.6-83l0.9-2038.2C722.3,527.5,763,470.6,813.3,470.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M854.5,525.5h1792.8c48.9,0,88.3,55.5,87.4,123.1l-25.2,1923.8c-1.2,90.5-55,162.8-120.5,161.6 l-1736.4-30.1c-47.9-0.8-86.3-54.7-86.3-120.9l0.8-1936.6C767.1,579.5,806.2,525.5,854.5,525.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 2113.2566,
    y1: -438.2235,
    x2: 1540.7167,
    y2: 1315.7449
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2731.9,813.7H766.2V545.3c0-14.3,11.6-25.9,25.9-25.9h1915.3c13.5,0,24.4,10.9,24.4,24.4V813.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2512.9,688.2l-1019.8-9.7c-24-0.2-43.4-16.1-43.4-35.6l0-34c0-15.1,15-27.3,33.6-27.3h1036.9 c18.3,0,32.7,12.6,31.4,27.4l-4.9,54C2545.4,677.4,2530.6,688.4,2512.9,688.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M2641.6,989.5H856.5c-11.8,0-21.4-9.6-21.4-21.4V911c0-11.9,9.7-21.5,21.6-21.4l1785.1,15.7 c11.8,0.1,21.3,9.6,21.3,21.4v41.4C2663,979.9,2653.4,989.5,2641.6,989.5z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1283.1,679.8c-29,0-52.6-23.6-52.6-52.6c0-29,23.6-52.6,52.6-52.6s52.6,23.6,52.6,52.6 C1335.7,656.2,1312.1,679.8,1283.1,679.8z M1283.1,581.2c-25.3,0-45.9,20.6-45.9,45.9c0,25.3,20.6,45.9,45.9,45.9 s45.9-20.6,45.9-45.9C1329,601.9,1308.4,581.2,1283.1,581.2z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1112.5,683.8c-29,0-52.6-23.6-52.6-52.6c0-29,23.6-52.6,52.6-52.6s52.6,23.6,52.6,52.6 C1165.1,660.2,1141.5,683.8,1112.5,683.8z M1112.5,585.2c-25.3,0-45.9,20.6-45.9,45.9c0,25.3,20.6,45.9,45.9,45.9 c25.3,0,45.9-20.6,45.9-45.9C1158.5,605.9,1137.9,585.2,1112.5,585.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M948.6,683.8c-29,0-52.6-23.6-52.6-52.6c0-29,23.6-52.6,52.6-52.6c29,0,52.6,23.6,52.6,52.6 C1001.2,660.2,977.6,683.8,948.6,683.8z M948.6,585.2c-25.3,0-45.9,20.6-45.9,45.9c0,25.3,20.6,45.9,45.9,45.9 c25.3,0,45.9-20.6,45.9-45.9C994.6,605.9,974,585.2,948.6,585.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1935.9,1161.8l-333.9-2.8c-10.5-0.1-18.9-8.6-18.8-19.1l0.1-9.3c0.1-10.2,8.3-18.5,18.5-18.8l334-8.3 c10.7-0.3,19.5,8.4,19.4,19.1l-0.2,20.3C1954.9,1153.5,1946.4,1161.9,1935.9,1161.8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M2007.9,1768.5l-491.6-4.1c-16.6-0.1-30-13.7-29.8-30.3l4.1-492.3c0.1-16.3,13.2-29.5,29.5-29.8l485.4,9.2 c20.6,0.4,37,17.3,36.8,37.8l-4.1,479.7C2038.1,1755.2,2024.5,1768.6,2007.9,1768.5z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1314.8,1161.8L981,1159c-10.5-0.1-18.9-8.6-18.8-19.1l0.1-9.3c0.1-10.2,8.3-18.5,18.5-18.8l334-8.3 c10.7-0.3,19.5,8.4,19.4,19.1l-0.2,20.3C1333.8,1153.5,1325.3,1161.9,1314.8,1161.8z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1386.8,1768.5l-491.6-4.1c-16.6-0.1-30-13.7-29.8-30.3l4.1-492.3c0.1-16.3,13.2-29.5,29.5-29.8l485.4,9.2 c20.6,0.4,37,17.3,36.8,37.8l-4.1,479.7C1417,1755.2,1403.4,1768.6,1386.8,1768.5z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M2558.9,1173.4l-333.9-2.8c-10.5-0.1-18.9-8.6-18.8-19.1l0.1-9.3c0.1-10.2,8.3-18.5,18.5-18.8l334-8.3 c10.7-0.3,19.5,8.4,19.4,19.1l-0.2,20.3C2577.9,1165.1,2569.3,1173.5,2558.9,1173.4z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M2630.8,1780.1l-491.6-4.1c-16.6-0.1-30-13.7-29.8-30.3l4.1-492.3c0.1-16.3,13.2-29.5,29.5-29.8l485.4,9.2 c20.6,0.4,37,17.3,36.8,37.8l-4.1,479.7C2661,1766.9,2647.5,1780.2,2630.8,1780.1z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M2653.4,2181.5c0,33-27,59.7-60,59.2l-1707.1-25c-28.4-0.4-51.3-23.6-51.3-52v-296.1 c0-28.9,23.6-52.3,52.5-52l1714.3,14.5c28,0.2,50.8,22.6,51.6,50.6V2181.5z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M2580.9,2445.5l-1699-21.8c-26-0.3-46.9-21.5-46.9-47.5V2307c0-17.7,14.5-32.1,32.2-31.8l1750.8,23.1 c25,0.3,45,20.7,45,45.6v20.6C2663,2409.6,2626.1,2446.1,2580.9,2445.5z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 2107.189,
    y1: 1814.7675,
    x2: 1570.6017,
    y2: 2649.6453
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M661.4,1108.7C391.6,1451.7,451,1948.4,794,2218.1c278.8,219.2,659.1,221.1,936.6,29.9l1191.7,937.2 c19.8,15.6,46.2,19.9,69.9,11.6l145.3-51.2c2.5-0.9,4.9-1.9,7.2-3c0.7-0.3,1.3-0.7,1.9-1c1.8-0.9,3.5-1.9,5.1-2.9 c0.6-0.4,1.1-0.7,1.7-1.1c2.1-1.4,4.1-2.8,6-4.3c0,0,0.1,0,0.1-0.1c20.3-16.6,30.8-43.2,25.9-70.2l-52.3-285.4 c-3.2-17.6-12.8-33.5-26.9-44.6l-119.4-93.9l-49.1,62.5l-102.5-80.6l49.1-62.5l-95.9-75.4l-45.2,57.5l-124.6-98l45.2-57.5 l-46.4-36.5l-23.3,29.6l-104.5-82.2l23.3-29.6l-81.3-63.9l-49.1,62.5l-58-45.6l49.1-62.5l-50.3-39.6l-49.1,62.5l-100.6-79.1 l49.1-62.5l-141.4-111.2h0l-60.6-47.6c120.4-314.7,29-683.9-249.8-903.1C1427.8,706.3,931.1,765.7,661.4,1108.7z M1102.7,1252.3 c69.4,54.6,81.5,155.2,26.9,224.7c-54.6,69.5-155.2,81.5-224.7,26.9c-69.4-54.6-81.5-155.2-26.9-224.7 C932.7,1209.7,1033.3,1197.6,1102.7,1252.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 1692.4974,
    y1: 3290.9399,
    x2: 2517.3333,
    y2: 2231.1511
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1689.5,1558.7l564.9,444.3l-49.1,62.5l100.6,79.1l49.1-62.5l50.3,39.6l-49.1,62.5l58,45.6l49.1-62.5 l81.3,63.9l-23.3,29.6l104.5,82.2l23.3-29.6l46.4,36.5l-45.2,57.5l124.6,98l45.2-57.5l95.9,75.4l-49.1,62.5l102.5,80.6l49.1-62.5 l119.4,93.9c14.1,11.1,23.6,26.9,26.9,44.6l52.3,285.4c6.5,35.6-13.8,70.6-47.9,82.6l-145.3,51.2c-23.7,8.4-50.1,4-69.9-11.6 L1515.6,2018.8L1689.5,1558.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 731.3109,
    y1: 885.2842,
    x2: 2355.7549,
    y2: 4695.3428,
    gradientTransform: "matrix(0.9978 -6.620000e-02 6.620000e-02 0.9978 109.8979 -93.4791)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M825.9,2183.1c343,269.7,839.7,210.4,1109.4-132.6c269.7-343,210.4-839.7-132.6-1109.4 S963,730.6,693.3,1073.6C423.5,1416.6,482.9,1913.3,825.9,2183.1z M936.8,1468.7c-69.4-54.6-81.5-155.2-26.9-224.7 c54.6-69.5,155.2-81.5,224.7-26.9c69.4,54.6,81.5,155.2,26.9,224.7C1106.8,1511.3,1006.2,1523.3,936.8,1468.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 649.7552,
    y1: 2981.4656,
    x2: 2569.6667,
    y2: 1621.5289
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1762.5,2213l1191.7,937.2c19.8,15.6,46.2,19.9,69.9,11.6l145.3-51.2c21.9-7.7,38-25,45.1-45.7 c-94.6-155.3-1142.9-888-1165.1-999.9c-7.9-39.8,0.7-96,63.8-173.1l-60.6-47.6c120.4-314.7,29-683.9-249.8-903.2 c-343-269.7-839.7-210.4-1109.4,132.6c-269.7,343-210.4,839.7,132.6,1109.4C1104.6,2402.3,1485,2404.1,1762.5,2213z  M1134.6,1217.2c69.4,54.6,81.5,155.2,26.9,224.7c-54.6,69.5-155.2,81.5-224.7,26.9c-69.4-54.6-81.5-155.2-26.9-224.7 C964.6,1174.6,1065.1,1162.6,1134.6,1217.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 1628.3843,
    y1: 163.8,
    x2: 1163.4757,
    y2: 2233.3967
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M921.7,2061.2c275.7,216.8,674.9,169.1,891.7-106.6c216.8-275.7,169.1-674.9-106.6-891.7 c-275.7-216.8-674.9-169.1-891.7,106.6C598.3,1445.2,646.1,1844.4,921.7,2061.2z M936.8,1468.7c-69.4-54.6-81.5-155.2-26.9-224.7 c54.6-69.5,155.2-81.5,224.7-26.9c69.4,54.6,81.5,155.2,26.9,224.7C1106.8,1511.3,1006.2,1523.3,936.8,1468.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 4770.8511,
    y1: 3228.8467,
    x2: 4952.1196,
    y2: 3228.8467,
    gradientTransform: "matrix(1 0 0 1 -3769.1077 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1177.9,3220.1c-31.1,2.7-84.9,7-127.4,8.9c-25.5,1.1-40.2-1.4-48.7-4.8c0,1,0,1.9,0.1,2.7 c0.2,4.5,3.8,8,8.3,8.3c80.3,4.5,144.1,1.6,166.9,0.2c4.7-0.3,7.5-5.4,5.1-9.4C1180.9,3224,1179.5,3222,1177.9,3220.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 4770.8408,
    y1: 3193.3206,
    x2: 4947.001,
    y2: 3193.3206,
    gradientTransform: "matrix(1 0 0 1 -3769.1077 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M1050.5,3229c42.5-1.9,96.4-6.2,127.4-8.9c-30.5-37.5-127.4-62.7-127.4-62.7h-27.4 c-18.8,27.1-21.6,53-21.3,66.9C1010.2,3227.6,1024.9,3230.1,1050.5,3229z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 4787.5864,
    y1: 3143.7209,
    x2: 4838.646,
    y2: 3143.7209,
    gradientTransform: "matrix(1 0 0 1 -3769.1077 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M1018.5,3112.7l2.6,50.7c0.3,5.5,4.4,10.1,9.9,10.9c5.5,0.8,12.8,0.9,20.6-1.7c4.8-1.6,8.3-5.6,9.2-10.5 l8.9-49.3H1018.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 4409.4775,
    y1: 3224.9375,
    x2: 4478.9429,
    y2: 3224.9375,
    gradientTransform: "matrix(1 0 0 1 -3769.1077 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M663,3228.6c-13.5-1.9-19.6-8.9-22.1-16.4c0,0.1,0,0.1-0.1,0.2c-2,7.9,2.6,16.1,11.8,20 c11.1,4.7,23.2,5.5,32.7,5.1c10.1-0.4,19.4-4.6,24.5-11.3l0.1-0.1C699.7,3231.2,685.4,3231.7,663,3228.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 4409.9829,
    y1: 3171.4514,
    x2: 4511.9438,
    y2: 3171.4514,
    gradientTransform: "matrix(1 0 0 1 -3769.1077 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M726.5,3112.4h-22.6c-34.4-0.7-56,71.8-63,99.9c2.6,7.5,8.6,14.5,22.1,16.4c22.5,3.1,36.7,2.5,46.8-2.5 c18.6-24.4,27.8-60.2,32.2-81.1C747.1,3121.2,726.5,3112.4,726.5,3112.4z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 4462.9805,
    y1: 3101.156,
    x2: 4524.002,
    y2: 3101.156,
    gradientTransform: "matrix(1 0 0 1 -3769.1077 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M706.8,3065.3l-12.5,49.8c-1.5,6.1,1.4,12.4,7,15.3c7,3.6,16.9,7.4,26,6.3c4.3-0.5,7.8-3.5,9.2-7.5 l18.4-52.4L706.8,3065.3z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 4089.418,
    y1: 3542.3274,
    x2: 4891.0288,
    y2: 2635.3943,
    gradientTransform: "matrix(1 0 0 1 -3769.1077 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M691.9,3079.7c15.6,13.8,66.3,15.7,66.3,15.7c182.7-438.5,257.4-500.8,257.4-500.8 c-26.4,165.5-4.3,531.9-4.3,531.9c30.1,13.3,69,0,69,0c2.4-271,44.1-507.3,93.3-693.6c-123.5-2.8-189.2-45-210.6-62 C860.2,2536.9,691.9,3079.7,691.9,3079.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 1667.2993,
    y1: 1270.5028,
    x2: 806.3169,
    y2: 2578.5349
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M994.4,1866.7c-23.4,116.6-15,325.2-9.5,420.4c1.5,26.8-17.1,63.8-32.2,89.1c-2.4,4-0.9,9,3.2,11.2 c25.3,13,110.9,53.2,210.1,58.2c6.6,0.3,12.5-4.2,14.2-10.6c73.6-274.8,159.1-450.4,159.1-450.4 C1245,1834,994.4,1866.7,994.4,1866.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 4668.6152,
    y1: 2875.1743,
    x2: 4697.855,
    y2: 2816.6948,
    gradientTransform: "matrix(1 0 0 1 -3769.1077 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M1028.1,2584.2c-1,0-2.1-0.3-3-0.9c-2.8-1.7-3.6-5.3-2-8c1-1.6,24.6-39.8,72.4-62.9 c2.9-1.4,6.4-0.2,7.8,2.7c1.4,2.9,0.2,6.4-2.7,7.8c-44.6,21.5-67.3,58.1-67.5,58.4C1032,2583.2,1030.1,2584.2,1028.1,2584.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 4742.5474,
    y1: 2211.6912,
    x2: 4525.3218,
    y2: 2404.0496,
    gradientTransform: "matrix(1 0 0 1 -3769.1077 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M847.8,2201.3c7.5,54.3,29.7,113.5,74.1,176.5l16.9-13.8c0,0-19.5-79-8.4-168.7 C903,2190,870.7,2195.5,847.8,2201.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 1516.5974,
    y1: 1171.3091,
    x2: 655.6151,
    y2: 2479.3413
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M1020.5,2010.5l-26.1-143.8c0,0-174.4,133.3-146.6,334.6c22.8-5.8,55.2-11.3,82.5-5.9 C938.3,2130.8,962.2,2060.7,1020.5,2010.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 1846.3042,
    y1: 1388.3304,
    x2: 985.3217,
    y2: 2696.363
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M1339.4,1984.7l-67.3,145c10.9,87.5,57.9,125.4,108.6,139.9c3.2-39.9,13.3-72.1,22.6-94.4 C1338.5,2108.3,1339.4,1984.7,1339.4,1984.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 5149.7617,
    y1: 2229.8862,
    x2: 5320.8359,
    y2: 2229.8862,
    gradientTransform: "matrix(1 0 0 1 -3769.1077 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M1403.3,2175.2c-9.4,22.3-19.4,54.5-22.6,94.4c135.3,52.5,171.1-49.3,171.1-49.3l-25-4.4 C1470.3,2221.8,1430.8,2203.6,1403.3,2175.2z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 1085.9943,
    y1: 2010.8724,
    x2: 1279.2996,
    y2: 1802.5692
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M1277.3,1805.7l-32.5,119.5c-3.7,13.4-18.2,20.6-31.1,15.5c-13.9-5.6-31.6-13.2-46.8-21.4 c-16.3-8.8-21.3-29.7-11-45l67.6-100.8L1277.3,1805.7z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 4667.9434,
    y1: 2355.2048,
    x2: 5563.7827,
    y2: 2355.2048,
    gradientTransform: "matrix(1 0 0 1 -3769.1077 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M1613.7,2140.3l-832.9,303.1c-34.9,12.7-51.6,52.5-36.2,86.3l2.5,5.6c13.6,29.9,49,43.1,78.9,29.3 l808.7-374.1L1613.7,2140.3z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st29"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 1996.6,
    cy: 1958,
    rx: 411.1,
    ry: 403.7
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 5308.167,
    y1: 1957.9736,
    x2: 6223.1631,
    y2: 1957.9736,
    gradientTransform: "matrix(1 0 0 1 -3769.1077 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M1996.6,1508.7c-252.7,0-457.5,201.1-457.5,449.2c0,248.1,204.8,449.2,457.5,449.2 c252.7,0,457.5-201.1,457.5-449.2C2454.1,1709.9,2249.2,1508.7,1996.6,1508.7z M1996.6,2341.2c-215.6,0-390.3-171.6-390.3-383.3 c0-211.7,174.7-383.3,390.3-383.3c215.6,0,390.3,171.6,390.3,383.3C2386.9,2169.6,2212.1,2341.2,1996.6,2341.2z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1573.8,2013.6c-1.5,0-2.9-1.1-3-2.7c-1.4-10.7-2.3-21.5-2.8-32.2c-0.1-1.7,1.2-3.1,2.9-3.2 c2-0.1,3.1,1.2,3.2,2.9c0.5,10.5,1.5,21.2,2.8,31.7c0.2,1.7-1,3.2-2.7,3.4C1574.1,2013.6,1574,2013.6,1573.8,2013.6z M1577,1888 c-0.2,0-0.4,0-0.5,0c-1.7-0.3-2.8-1.9-2.5-3.6c5.2-28.9,13.5-57.3,24.7-84.5l0,0c65.9-160,222.1-263.4,397.9-263.4 c82,0,161.6,22.8,230.4,65.8c1.4,0.9,1.9,2.8,1,4.2c-0.9,1.4-2.8,1.9-4.2,1c-67.8-42.5-146.4-64.9-227.2-64.9 c-173.3,0-327.2,101.9-392.2,259.6c0,0,0,0,0,0c-11,26.7-19.2,54.7-24.3,83.2C1579.7,1887,1578.4,1888,1577,1888z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 4715.7236,
    y1: 3914.8518,
    x2: 4558.4668,
    y2: 4122.8896,
    gradientTransform: "matrix(0.9897 -0.1428 0.1428 0.9897 -3908.1624 -1480.9402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M1348.4,1714.9c0.3,2.1-27.1,136.4-27.1,136.4L1245,1834l7.1-131.1 C1252,1702.8,1343.5,1680.5,1348.4,1714.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 3803.032,
    y1: 1754.4205,
    x2: 4348.6436,
    y2: 1823.4059,
    gradientTransform: "matrix(1 0 0 1 -2628.3743 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M1269.2,1732l-9.1,68.7c-0.1,0.9-0.1,1.8,0,2.6c0.8,5.4,4.8,23.7,23.3,18.5c16.8-4.8,32.2-8.9,42.9-5.6 c4.8,1.5,7.7,6.3,6.7,11.2c-2.5,12.2-8.6,39.6-17.6,62.6c-1.8,4.7-6.9,7.1-11.7,5.7c-14.5-4.2-44.8-14-67.3-27.5 c-3.1-1.8-4.9-5.2-4.7-8.7c0.7-17.4,2.8-70.1,1.1-84.9c-1.6-13.9-18.6-22.2-26-25.2c-2.4-1-4.3-2.9-5.3-5.3 c-3.4-8.6-8.2-28.5,16.9-36.6c5.2-1.7,8-7.4,6.1-12.5c-3.7-10.3-5.3-26.1,14.1-34.8c19.7-8.8,34.4,1.7,42.3,10.2 c3.2,3.4,8.4,4,12.3,1.5c2.3-1.4,5.2-1.9,8.7,0.3c4.8,3,11.1,0.9,13.5-4.1c4.7-9.7,14.3-20.1,33.6-16.7 c34.2,5.9,38.1,43.8,29.1,66c-9,22.2-45.8,13.8-64.2,2.6c-14-8.5-32.2,0.4-40.1,5.2C1271.3,1726.6,1269.6,1729.1,1269.2,1732z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 4579.6543,
    y1: 3982.9038,
    x2: 4705.7871,
    y2: 3853.4951,
    gradientTransform: "matrix(0.9897 -0.1428 0.1428 0.9897 -3908.1624 -1480.9402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M1229.6,1799.7c0,0,14.1-39.4-0.4-49c-14.5-9.6-35.9-4.6-31.1,23.9 C1203.9,1810,1229.6,1799.7,1229.6,1799.7z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 4828.3301,
    y1: 2308.5637,
    x2: 4611.1045,
    y2: 2500.9216,
    gradientTransform: "matrix(1 0 0 1 -3769.1077 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M931.8,2361.6l78.7-6.4l34.1,31.4c0,0-8.1,11.2-33.3,4.7c-25.2-6.4-59.8-8-59.8-8s-34.8,15.7-35.2-13.7 L931.8,2361.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 5329.3237,
    y1: 2209.7947,
    x2: 5390.5864,
    y2: 2209.7947,
    gradientTransform: "matrix(1 0 0 1 -3769.1077 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M1541.7,2238.9c6.8,5.3,30.1-5.8,44.4-13.5c7-3.7,10.3-11.9,7.9-19.4c-3.4-10.8-9.2-24.8-16.2-26.6 C1566.1,2176.5,1513.6,2217,1541.7,2238.9z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M797.3,2552.9c-0.3,0-0.7-0.1-1-0.2c-32.5-11.3-40.1-30.5-40.7-44.6c-0.9-20.7,12.1-39.9,32.3-47.7l100-39 c1.6-0.6,3.3,0.2,4,1.7c0.6,1.6-0.2,3.4-1.7,4l-100,39c-17.8,6.9-29.2,23.7-28.4,41.7c0.8,17.8,13.1,30.9,36.6,39.1 c1.6,0.6,2.5,2.3,1.9,3.9C799.7,2552.2,798.6,2552.9,797.3,2552.9z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M919.8,2415.3c-1.2,0-2.4-0.7-2.9-2c-0.6-1.6,0.2-3.4,1.7-4l13-5.1c1.6-0.6,3.4,0.2,4,1.7 c0.6,1.6-0.2,3.4-1.7,4l-13,5.1C920.6,2415.3,920.2,2415.3,919.8,2415.3z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.32e055d4e7b38d40cfd478a3dd253a9b.svg";
export { ForwardRef as ReactComponent };